import { UAScript } from 'components/google_analytics/ua_script'
import { GtagScript } from 'components/google_analytics/gtag_script'

export const GoogleAnalyticsScript = () => (
  <>
    <UAScript />
    <GtagScript />
  </>
)
